'use client';

import {trpc} from '@features/utils/trpc';
import {DINAMO_FONT_FACE_CSS} from './dinamoFontFaceCss';

/**
 * Emits the bundled Dinamo `@font-face` declarations into the document only
 * when the current flow was created from the admin Taste panel. Without this
 * gate, the rules would live in `app/globals.css` and any user-created flow
 * could render with Dinamo just by referencing the family name in CSS.
 *
 * Public — `taste.isTasteFlow` is a `baseProcedure` so non-admin viewers
 * (anyone with the flow URL) can still see the fonts when the flow is
 * admin-Taste-created.
 *
 * Mount once per flow page (canvas + preview) above the screen-rendering
 * frames. Silent no-op for user-created flows.
 */
export function DinamoFontFaces({flowId}: {flowId: string}) {
  const {data: isTasteFlow} = trpc.taste.isTasteFlow.useQuery(
    {flowId},
    {
      staleTime: 5 * 60_000,
      retry: false,
    },
  );

  if (!isTasteFlow) return null;

  return <style dangerouslySetInnerHTML={{__html: DINAMO_FONT_FACE_CSS}} />;
}
